import React, { useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import ReactHtmlParser from 'react-html-parser';

import useServerSideRendering from '@hooks/useServerSideRendering';

interface CustomToasterProps {
  flashMessages?: string[];
}

const CustomToaster = ({ flashMessages }: CustomToasterProps) => {
  const hydrated = useServerSideRendering();

  useEffect(() => {
    if (hydrated && flashMessages) {
      flashMessages.forEach((flash) => toast.success(ReactHtmlParser(flash)));
    }
  }, [hydrated, flashMessages]);

  return (
    <Toaster
      position="top-center"
      reverseOrder={true}
      containerClassName="w-[calc(100%-32px)] left-16 right-16 sm:left-28 sm:right-28 sm:w-[calc(100%-56px)] lg:w-full lg:left-1/2 lg:right-auto lg:-translate-x-1/2"
      containerStyle={{
        bottom: -8,
        position: 'absolute',
        right: null,
        left: null,
        top: 'auto',
      }}
      toastOptions={{
        className:
          'font-suisse-intl-mono w-full sm:w-fit rounded-none bg-primary-magenta text-disclosure-sm sm:text-disclosure-lg py-8 px-64 text-white font-bold sm:font-normal max-w-full text-center lg:max-w-container-lg lg:mx-28',
        duration: 5000,
        icon: null,
        error: {
          style: {
            background: '#f32a52',
          },
        },
      }}
    />
  );
};

export default CustomToaster;
